<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
  >
    <path d="M7.10433 1.39899C7.47114 0.655739 8.53099 0.655744 8.8978 1.39899L10.8282 5.31048L15.1448 5.93772C15.9651 6.05691 16.2926 7.06488 15.699 7.64342L12.5755 10.6881L13.3129 14.9872C13.453 15.8042 12.5956 16.4271 11.8619 16.0414L8.00106 14.0116L4.14018 16.0414C3.40655 16.4271 2.54913 15.8041 2.68924 14.9872L3.4266 10.6881L0.303081 7.64341C-0.290438 7.06488 0.0370772 6.05691 0.857295 5.93772L5.17389 5.31048L7.10433 1.39899Z" fill="#FFC259"/>
  </svg>
</template>
